import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { getNikkiHeadcountDbPageConfigs } from './nikki-headcount-db-page-configs';

const dashboardId = 'global_hr_headcount';
export const NikkiHeadcountDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Global HR Headcount',
    [Languages.JA]: 'Global HR Headcount',
  },
  enabled: true,
  pages: getNikkiHeadcountDbPageConfigs(dashboardId),
};
